import type { WalkInHours } from "../controller";

export const hoursNotAvailable = (walkInHours: WalkInHours) =>
    Object.values(walkInHours ?? {}).every(
        ({ close, open }) => close === "00:00" && open === "00:00"
    );
